import {React, useState, useEffect} from 'react';
import jawlogo from '../../Images/jaw-logo.png';
import ranelogo from '../../Images/Wabco.jpg';
import wabco1 from '../../Images/wabco1.jpg';
import wabco2 from '../../Images/wabco2.jpg';
import wabco3 from '../../Images/wabco3.jpg';
import wabco4 from '../../Images/wabco4.jpg';
import wabco5 from '../../Images/wabco5.jpg';
import wabco6 from '../../Images/wabco6.jpg';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

// Placeholder images for the gallery and QR codes.
// Replace these with your actual image imports.
const galleryImages = [
 wabco1,
 wabco2,
 wabco3,
 wabco4,
 wabco5,
 wabco6,
];

const qrCodeHospet = 'https://via.placeholder.com/150';
const qrCodeChitradurga = 'https://via.placeholder.com/150';

const API_BASE_URL = (process.env.NODE_ENV === 'production' ? 'https://japl-backend-v2jm.onrender.com/api' : 'http://localhost:5000/api')
// const API_BASE_URL = 'http://localhost:5000/api'


const JAW_WABCO = () => {

      // State for backend QR URLs for RANE sub-branches
    const [qrHospet, setQrHospet] = useState(null);
    const [qrChitradurga, setQrChitradurga] = useState(null);
  
    // Fetch QR for RANE Hospet and Chitradurga on mount
    useEffect(() => {
      async function fetchQRs() {
        try {
          const res1 = await fetch(`${API_BASE_URL}/branchqrcode/Wabco::Hospet`);
          if (res1.ok) {
            const data1 = await res1.json();
            setQrHospet(data1.qrCodeImageURL.startsWith('http') ? data1.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data1.qrCodeImageURL.replace(/^\//, '')}`);
          } else {
            setQrHospet(null);
          }
  
          const res2 = await fetch(`${API_BASE_URL}/branchqrcode/Wabco::Chitradurga`);
          if (res2.ok) {
            const data2 = await res2.json();
            setQrChitradurga(data2.qrCodeImageURL.startsWith('http') ? data2.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data2.qrCodeImageURL.replace(/^\//, '')}`);
          } else {
            setQrChitradurga(null);
          }
        } catch {
          setQrHospet(null);
          setQrChitradurga(null);
        }
      }
      fetchQRs();
    }, []);
  

  return (
    <div className=''>
      <section className="relative h-[390px] md:h-[370px] lg:h-[400px] w-full flex items-center justify-center overflow-hidden">
    {/* Background image */}
    <img
      src={wabco1}
      alt="Engine Workshop Background"
      className="absolute inset-0 w-full h-[390px] md:h-[370px] lg:h-[400px] object-cover object-center"
      style={{ zIndex: 1 }}
    />
    {/* Backdrop overlay for readability */}
    <div
      className="absolute inset-0 h-[390px] md:h-[370px] lg:h-[400px] bg-black/30"
      style={{ zIndex: 2 }}
    />

    {/* Content Row */}
    <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-6xl px-6 pt-12">
      {/* Logo */}
      <div className="flex flex-col items-center justify-center text-white w-full">
        <img
          src={jawlogo}
          alt="JAW Logo"
          className="w-20 h-20 object-cover drop-shadow-xl rounded-full mx-auto sm:mx-0"
        />
      </div>

      {/* Headings */}
      <h1 className="text-white text-3xl md:text-5xl font-bold tracking-tight leading-tight text-center drop-shadow-lg mt-4">
        JANATHA AUTO WORKS
      </h1>
      <div className="bg-blue-500 p-2 text-center rounded-xl mt-4 text-lg md:text-xl font-semibold text-white drop-shadow-sm max-w-full">
        WABCO AUTHORISED SERVICE CENTRE
      </div>
      <div className="mt-4 text-lg md:text-xl font-semibold text-white drop-shadow-sm max-w-full text-center">
        Trusted. Trained. Technologically Advanced. Your official WABCO Authorized Service Center for commercial vehicle control systems.
      </div>
    </div>
  </section>
      
      {/* Description Section */}
      <div className='pt-12 mx-auto px-4 sm:px-8 md:px-12 lg:px-20'>
       <div className='flex justify-center items-center pb-4'>
         <img src={ranelogo} alt="rane-logo" className='h-16 md:h-24 content-center' />
       </div>
        <div className='flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left'>
          <h2 className='text-2xl md:text-4xl  font-bold text-gray-900 font-sans mt-4 md:mt-0'>Advanced Brake Solutions Since 2015</h2>
        </div>
        <p className='px-4 md:px-20 text-center text-sm md:text-lg lg:text-xl pt-4 text-gray-700'>
       At Janatha Auto Works, we are proud to serve as an Authorized Service Center for WABCO, a global leader in commercial vehicle control systems and advanced braking technologies. Our partnership with WABCO began in 2015 with our Chitradurga ASC and expanded to Hospet in 2019, bringing OEM-grade brake system servicing to the region.
        </p>
      </div>

      {/* 3-Cards Section */}
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 py-12'>
        {/* Card 1 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          <img src={wabco1} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' />
          <h3 className='text-lg md:text-xl font-semibold text-center py-2'>Factory-Certified Expertise</h3>
          <p className='text-center text-sm md:text-base'>Our technicians are trained by WABCO professionals to handle everything from routine maintenance to complex diagnostics with precision and care.</p>
        </div>

        {/* Card 2 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          <img src={wabco2} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' />
          <h3 className='text-lg md:text-xl font-semibold text-center py-2'>Genuine Parts Inventory</h3>
          <p className='text-center text-sm md:text-base'>We maintain a comprehensive stock of genuine WABCO parts to ensure rapid turnaround times and minimal downtime for your fleet.</p>
        </div>

        {/* Card 3 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          <img src={wabco3} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' />
          <h3 className='text-lg md:text-xl font-semibold text-center py-2'>Comprehensive Brake Solutions</h3>
          <p className='text-center text-sm md:text-base'>From preventive maintenance to emergency repairs, we offer complete WABCO brake system services to keep your vehicles safe on the road.</p>
        </div>
      </div>

      {/* Commitment Section */}
      <div className='grid grid-cols-1 md:grid-cols-2 p-8 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 shadow-2xl rounded-lg bg-gray-50'>
        <div className='space-y-4'>
          <h3 className='text-2xl md:text-3xl font-semibold text-gray-800'>Why Choose Our WABCO Service?</h3>
        <p>As an officially certified WABCO ASC since 2015, we guarantee:</p>
          <ul className='space-y-2 text-sm md:text-base text-gray-600'>
            <li>✓ 100% Genuine WABCO Parts</li>
            <li>✓ Factory-Trained Technicians</li>
            <li>✓ Advanced Diagnostic Equipment</li>
            <li>✓ Warranty-Compliant Services</li>
            <li>✓ Rapid Response Times</li>
          </ul>
        </div>
        <div>
          <img src={wabco4} alt="rane-4" className='w-full h-48 md:h-72 object-cover rounded-xl' />
        </div>
      </div>
      
      {/* Gallery Section */}
      <div className='py-12 mx-4 sm:mx-8 md:mx-12 lg:mx-20 pt-12'>
        <h2 className='text-3xl md:text-4xl font-bold text-center mb-8 text-gray-900'>Gallery</h2>
        <div className='grid grid-cols-2 md:grid-cols-3  gap-4'>
          {galleryImages.map((image, index) => (
            <div key={index} className='overflow-hidden rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105'>
              <img src={image} alt={`Gallery image ${index + 1}`} className='w-full h-40 md:h-52 object-cover' />
            </div>
          ))}
        </div>
      </div>

      {/* Contact/Footer Section as per image */}
      <div className='py-12 bg-gray-900 text-white text-center px-4 sm:px-8 md:px-12 lg:px-20'>
        <div className='max-w-4xl mx-auto'>
          <h2 className='text-2xl md:text-3xl lg:text-4xl font-bold pt-4 font-sans mb-2 text-cyan-400'>Let's Keep Your Brakes Safe</h2>
          <p className='text-sm md:text-base text-gray-300 mb-8'>
           Need expert brake service, genuine WABCO parts, or fleet maintenance?
            Our WABCO specialists are ready to help.
          </p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
          {/* Card 1: Contact Information */}
          <div className='bg-gray-800 p-6 rounded-lg shadow-lg'>
            <h3 className='text-xl font-bold mb-4'>CONTACT INFORMATION</h3>
            <div className='space-y-4 text-left'>
              <div>
                <p className='text-sm font-semibold mb-1 text-blue-300'>Hospet</p>
                <div className='flex items-center space-x-2 text-gray-400'>
                  <FaPhoneAlt className='text-blue-400' />
                  <span>88840 13007</span>
                </div>
                <div className='flex items-center space-x-2 text-gray-400 mt-1'>
                  <FaEnvelope className='text-blue-400' />
                  <span>jaw.hpt@gmail.com</span>
                </div>
              </div>
              <hr className='border-gray-700' />
              <div>
                <p className='text-sm font-semibold mb-1 text-blue-300'>Chitradurga</p>
                <div className='flex items-center space-x-2 text-gray-400'>
                  <FaPhoneAlt className='text-blue-400' />
                  <span>9742153614</span>
                </div>
                <div className='flex items-center space-x-2 text-gray-400 mt-1'>
                  <FaEnvelope className='text-blue-400' />
                  <span>jaw.durga@gmail.com</span>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2: Hospet Address */}
          <div className='bg-gradient-to-br from-blue-900/50 to-cyan-800/50 p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
            <h3 className='text-xl font-bold mb-4'>HOSPET ADDRESS</h3>
            <p className='text-sm text-gray-400 mb-4'>Scan for directions</p>
         <img
              src={qrHospet || qrCodeHospet}
              alt="QR Code Hospet"
              className='w-40 h-40 rounded-lg bg-white'
            />
            <p className='mt-4 text-sm text-gray-400'>Janatha Auto Works - Near RTO Office, Harihar Road</p>
          </div>

          {/* Card 3: Chitradurga Address */}
          <div className='bg-gradient-to-br from-blue-900/50 to-cyan-800/50 p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
            <h3 className='text-xl font-bold mb-4'>CHITRADURGA ADDRESS</h3>
            <p className='text-sm text-gray-400 mb-4'>Scan for directions</p>
           <img
              src={qrChitradurga || qrCodeChitradurga}
              alt="QR Code Chitradurga"
              className='w-40 h-40 rounded-lg bg-white'
            />
            <p className='mt-4 text-sm text-gray-400'>Janatha Auto Works - Oppo Bapuji High School, NH-13 Road</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JAW_WABCO;